import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProdutoPageRoutingModule } from './produto-page-routing.module';
import { ProdutoPageComponent } from 'src/app/pages/produto/produto-page/produto-page.component';
import { ModuloModule } from 'src/app/modules/modulo/modulo.module';
import { ProdutoItemValorModule } from 'src/app/modules/produto/produto-item-valor/produto-item-valor.module';
import { ProdutoPartialModule } from 'src/app/modules/produto/produto-partial/produto-partial.module';
import { PipeModule } from 'src/app/modules/pipe/pipe.module';
import { LoaderModule } from 'src/app/modules/loader/loader/loader.module';
import { PartialModule } from 'src/app/modules/partial/partial.module';
import { FormsModule } from '@angular/forms';
import { CartAddModule } from 'src/app/modules/carrinho/cart-add/cart-add.module';
import { BtnCartAddModule } from 'src/app/modules/carrinho/btn-cart-add/btn-cart-add.module';


@NgModule({
  declarations: [
    ProdutoPageComponent
  ],
  exports: [
    ProdutoPageComponent
  ],
  imports: [
    CommonModule,
    ProdutoPageRoutingModule,
    ModuloModule, 
    ProdutoItemValorModule,
    ProdutoPartialModule,
    LoaderModule,
    PipeModule,
    PartialModule,  
    CommonModule,
    FormsModule,  
    PartialModule,
    CartAddModule,
    BtnCartAddModule
  ]
})
export class ProdutoPageModule { }
